import { render, staticRenderFns } from "./HostingEditor.vue?vue&type=template&id=bb021062"
import script from "./HostingEditor.vue?vue&type=script&lang=js"
export * from "./HostingEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports